import { PageSections, type SectionRenderers } from "@/components/cms/PageSections";
import { StoryCard } from "@/components/ui/Cards";
import { PageHeader } from "@/components/ui/PageHeader";
import { Reveal, RevealGroup } from "@/components/ui/Reveal";
import { Section } from "@/components/ui/Section";
import { useContent } from "@/content-context";
import { buildMetadata } from "@/lib/seo";
import { pageLoader } from "@/page-data";

export const loader = pageLoader("stories");

export const meta = () =>
  buildMetadata({
    title: "Stories from the field",
    description:
      "Reporting from HISCUS programmes in Nepal: the Bethanchowk water tank, Empowering with Dignity sessions, the Sarangkot Nestling Home, public dialogue and volunteering.",
    path: "/stories",
  });

function ListSection() {
  const { stories } = useContent();
  return (
    <Section>
      <RevealGroup as="ul" className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {stories.map((story) => (
          <Reveal as="li" key={story.slug}>
            <StoryCard story={story} />
          </Reveal>
        ))}
      </RevealGroup>
    </Section>
  );
}

export const storiesSections: SectionRenderers = {
  "stories.list": ListSection,
};

export function StoriesPage() {
  return (
    <>
      <PageHeader
        eyebrow="From the field"
        title="Stories from the work"
        lead="Written only from documented events. Dates, places and figures come from HISCUS reporting; no participant is named or quoted beyond what has been published."
        trail={[
          { name: "Home", href: "/" },
          { name: "Stories", href: "/stories" },
        ]}
      />
      <PageSections renderers={storiesSections} />
    </>
  );
}
